module.exports = __webpack_public_path__ + "img/maman-enfant.78ee56b4.png";